module.exports = __webpack_public_path__ + "static/3-a66de7c2b95e947a4fd4225639ebac61.png";